import { DownloadLeaderboardExcelRequest, ViewLeaderboardRequest } from './leaderboard.types';

import { API_HOST, HttpGetOptions, HttpPostOptions, getHttpGetOptions, getHttpPostOptions } from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/leaderboard`;
const getSpecificEndpoint = (externalReference: string) => `${getEndpoint()}/${externalReference}`;

export const getViewLeaderboardRequest = (data: ViewLeaderboardRequest): [string, HttpGetOptions] => [
  getSpecificEndpoint(data.programmeExternalReference),
  getHttpGetOptions()
];

export const getDownloadLeaderboardExcelRequest = (
  data: DownloadLeaderboardExcelRequest
): [string, HttpPostOptions<DownloadLeaderboardExcelRequest>] => [
  `${getEndpoint()}/excel/download`,
  getHttpPostOptions(data)
];
